export default "__VITE_ASSET__7e67f9b6__$_?component__"